import axiosInstance from '../../Helpers/api_helper';

interface EmailVerificationPayload {
  token: string;
}

export const emailTokenVerification = async (payload: EmailVerificationPayload): Promise<any> => {
  try {
    const response = await axiosInstance.post('api/v1/participants/emailTokenVerification', payload);
    
    // Check if the response contains a success status or relevant data
    if (response.data && response.data.status === "success") {
      return { status: "success", message: "Email verification successful", data: response.data };
    } else {
      console.error('Email verification failed:', response.data.message);
      return { status: "error", message: response.data.message || "Email verification failed." };
    }
  } catch (error: any) {
    console.error('Error during email verification:', error.message);
    throw error;
  }
};
